import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/firebase-config';
import { COLLECTIONS, DEFAULT_TENANT_ID, ROLES, SELECTABLE_TENANT_IDS } from '../platform/constants';

function memberDocRef(tenantId, uid) {
  return doc(db, COLLECTIONS.TENANTS, tenantId, COLLECTIONS.MEMBERS, uid);
}

function mapMembership(tenantId, uid, data) {
  const unitIds = Array.isArray(data.unitIds)
    ? data.unitIds.map(String)
    : [];

  return {
    tenantId,
    uid,
    role: data.role || ROLES.MEMBER,
    unitIds,
    status: data.status || 'active',
    isActive: (data.status || 'active') === 'active',
  };
}

/** Load tenants/{tenantId}/members/{uid} for selectable organizations. */
export async function loadMembershipsForUser(uid) {
  const memberships = [];

  for (const tenantId of SELECTABLE_TENANT_IDS) {
    try {
      const snapshot = await getDoc(memberDocRef(tenantId, uid));
      if (snapshot.exists()) {
        memberships.push(mapMembership(tenantId, uid, snapshot.data()));
      }
    } catch {
      // Ignore per-tenant read errors.
    }
  }

  return memberships;
}

export function getMembershipForTenant(memberships, tenantId) {
  if (!memberships?.length || !tenantId) {
    return null;
  }
  return (
    memberships.find(
      (membership) => membership.tenantId === tenantId && membership.isActive,
    ) ?? null
  );
}

export function canAccessTenant(memberships, tenantId) {
  return memberships.some(
    (membership) => membership.tenantId === tenantId && membership.isActive,
  );
}

export function resolveInitialTenantId(memberships, preferredTenantId) {
  if (preferredTenantId && canAccessTenant(memberships, preferredTenantId)) {
    return preferredTenantId;
  }

  const active = memberships.filter((membership) => membership.isActive);
  if (active.length > 0) {
    return active[0].tenantId;
  }

  return DEFAULT_TENANT_ID;
}
